import { CustomRoute } from "@/interfaces";
import { Building, Building2, Key, LayoutDashboard, Settings, Users, BarChart3 } from "lucide-react";
import React from "react";

const Dashboard = React.lazy(() => import("@/modules/SuperAdmin/Dashboard"));
const UserManagement = React.lazy(() => import("@/modules/SuperAdmin/UserManagement"));
const CompanyManagement = React.lazy(() => import("@/modules/SuperAdmin/CompanyManagement"));
const ClientManagement = React.lazy(() => import("@/modules/SuperAdmin/ClientManagement"));
const VendorManagement = React.lazy(() => import("@/modules/SuperAdmin/VendorManagement"));
// const Organization = React.lazy(() => import("@/modules/SuperAdmin/OrganizationManagement")); // Deprecated
const ServiceManagement = React.lazy(() => import("@/modules/SuperAdmin/ServiceManagement"));
const AccessTokenManagement = React.lazy(() => import("@/modules/SuperAdmin/AccessTokenManagement"));
const BillApprovalConfigs = React.lazy(() => import("@/modules/SuperAdmin/BillApprovalConfigs"));
const EditProfile = React.lazy(() => import("@/modules/Profile/EditProfile"));
const Reports = React.lazy(() => import("@/modules/SuperAdmin/Reports"));
const FinancialReports = React.lazy(() => import("@/modules/SuperAdmin/Reports/FinancialReports"));

const superAdminRoutes: CustomRoute[] = [
  {
    path: "/",
    id: "SuperAdmin",
    element: <Dashboard />,
    menuName: "Dashboard",
    icon: LayoutDashboard,
    highlightOn: ["dashboard"],
  },
  {
    path: "/users",
    id: "SuperAdmin",
    element: <UserManagement />,
    menuName: "User Management",
    icon: Users,
    highlightOn: ["users", "user"],
  },
  {
    path: "/companies",
    id: "SuperAdmin",
    element: <CompanyManagement />,
    menuName: "Company Management",
    icon: Building2,
    highlightOn: ["companies", "company"],
  },
  {
    path: "/companies/:id/edit/:tab",
    id: "SuperAdmin",
    element: <CompanyManagement />,
    menuName: "Edit Company",
    hideInMenu: true,
    highlightOn: ["companies", "company"],
  },
  {
    path: "/companies/:id/edit",
    id: "SuperAdmin",
    element: <CompanyManagement />,
    menuName: "Edit Company",
    hideInMenu: true,
    highlightOn: ["companies", "company"],
  },
  {
    path: "/clients",
    id: "SuperAdmin",
    element: <ClientManagement />,
    menuName: "Clients",
    icon: Users,
    highlightOn: ["clients", "client"],
  },
  {
    path: "/vendors",
    id: "SuperAdmin",
    element: <VendorManagement />,
    menuName: "Vendors",
    icon: Building,
    highlightOn: ["vendors", "vendor"],
  },
  // Organizations - Deprecated in favor of Client/Vendor first-class entities
  // {
  //   path: "/organizations",
  //   id: "SuperAdmin",
  //   element: <Organization />,
  //   menuName: "Organizations",
  //   icon: Building,
  //   highlightOn: ["organizations", "organization"],
  // },
  {
    path: "/services",
    id: "SuperAdmin",
    element: <ServiceManagement />,
    menuName: "Service Management",
    icon: Settings,
    highlightOn: ["services", "service"],
  },
  {
    path: "",
    id: "SuperAdmin",
    element: null,
    menuName: "Reports",
    icon: BarChart3,
    highlightOn: ["reports"],
    submenu: [
      {
        path: "/reports/general",
        id: "SuperAdmin",
        element: <Reports />,
        menuName: "General",
        highlightOn: ["reports-general"],
      },
      {
        path: "/reports/financials",
        id: "SuperAdmin",
        element: <FinancialReports />,
        menuName: "Financials",
        highlightOn: ["reports-financials"],
      }
    ]
  },
  {
    path: "/access-tokens",
    id: "SuperAdmin",
    element: <AccessTokenManagement />,
    menuName: "API Access Tokens",
    icon: Key,
    highlightOn: ["access-tokens", "tokens"],
  },
  {
    path: "/bill-approvals",
    id: "SuperAdmin",
    element: <BillApprovalConfigs />,
    menuName: "Bill Approvers",
    icon: Settings,
    highlightOn: ["bill-approvals"],
  },
  {
    path: "/profile",
    id: "SuperAdmin",
    element: <EditProfile />,
    menuName: "Profile",
    icon: Users,
    highlightOn: ["profile"],
  },
];

export default superAdminRoutes;
